import React from 'react';
import { getQuestionLabel } from '@/utils/dynamicForm.util';
import FormIndustriesSelect from '@/components/molecules/form/search/FormIndustriesSelect';
import { DynamicFormIndustriesProps } from './types';

/**
 * Dynamic form industries select field component
 * 
 * Wraps FormIndustriesSelect with getQuestionLabel and additional props
 * 
 * @param cfg - Field configuration object
 * @returns JSX element for the industries select field
 */
const DynamicFormIndustries: React.FC<DynamicFormIndustriesProps> = (cfg) => {
  return (
    <FormIndustriesSelect
      industryAllFormName={`${cfg.name}NACE`}
      {...cfg}
      label={getQuestionLabel(cfg)}
      helperTextBelowLabel
    />
  );
};

export default DynamicFormIndustries;